import React from "react";
import { useAppSelector } from "store/hooks";
import { ErrorMessage } from "@hookform/error-message";
import { Stack } from "@mui/material";
import { ReactComponent as Logo } from "images/rs-logo.svg";
import { useLogin } from "./Login.hook";
import {
  AuthContainer,
  AuthFormContent,
  AuthLink,
  AuthTitle,
  Input,
  SubmitButton,
  Error,
  InputLabel,
} from "SC";
import { Footer } from "./Footer";
import { DevIndicator } from "./DevIndicator";

export const Login = () => {
  const spinner = useAppSelector((state) => state.spinner);
  const {
    error,
    errors,
    onSubmit,
    passwordRegisterProps,
    usernameRegisterProps,
  } = useLogin();

  return (
    <AuthContainer>
      <DevIndicator />
      <Stack flex={1} gap={2} justifyContent={"center"} alignItems={"center"}>
        <Logo />
        <form onSubmit={onSubmit} className="mui-form">
          <AuthFormContent>
            <AuthTitle>Log In</AuthTitle>
            <Stack alignItems={"flex-start"}>
              <InputLabel htmlFor="email">Your email</InputLabel>
              <Input
                id="email"
                type="text"
                autoComplete="new-username"
                {...usernameRegisterProps}
                error={!!errors?.username}
              />
              <ErrorMessage
                errors={errors}
                name="username"
                render={({ message }) => <Error>{message}</Error>}
              />
            </Stack>
            <Stack alignItems={"flex-start"}>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Input
                id="password"
                type={"password"}
                autoComplete="new-password"
                {...passwordRegisterProps}
              />
              <ErrorMessage
                errors={errors}
                name="password"
                render={({ message }) => <Error>{message}</Error>}
              />
            </Stack>
            {!!error && <Error>{error}</Error>}
            <Stack direction={"row"} justifyContent={"flex-end"} gap={2}>
              <AuthLink to="/forgot">Forgot password?</AuthLink>
            </Stack>
            <SubmitButton
              type="submit"
              variant="contained"
              disabled={!!spinner}
              size="large"
            >
              Log in
            </SubmitButton>
          </AuthFormContent>
        </form>
        <div className="text-sm">
          Don't have an account? <AuthLink to="/sign_up">Register</AuthLink>
        </div>
      </Stack>
      <Footer />
    </AuthContainer>
  );
};
